export default "__VITE_ASSET__C9Uw_Gip__"